// Escape untrusted text before interpolating into print HTML.
export const esc = (v) => String(v ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

// Open a print-ready window with MobiMed styling and auto-trigger print (Save as PDF).
export function printDoc(title, bodyHtml, extraStyles = "") {
  const w = window.open("", "_blank");
  if (!w) return false;
  w.document.write(`<!doctype html><html><head><title>${esc(title)}</title><style>
    *{font-family:Arial,Helvetica,sans-serif;-webkit-print-color-adjust:exact;print-color-adjust:exact;box-sizing:border-box;}
    body{padding:28px;color:#111;} h1{font-size:20px;margin:0;color:#0b3b8c;}
    h2{font-size:14px;margin:2px 0 0;color:#333;} .muted{color:#666;font-size:12px;}
    .row{display:flex;justify-content:space-between;align-items:flex-start;gap:24px;}
    table{width:100%;border-collapse:collapse;font-size:12px;margin-top:14px;}
    th,td{border:1px solid #bbb;padding:6px 8px;text-align:left;} th{background:#eef2f8;}
    td.r,th.r{text-align:right;} tfoot td{font-weight:bold;background:#f7f9fc;}
    ${extraStyles}
  </style></head><body>${bodyHtml}<script>window.onload=function(){window.print();}</script></body></html>`);
  w.document.close();
  return true;
}
